import { useCallback } from 'react';
import { LOCAL_ACCOUNTS_BASE_URL } from '../consts';
import { usePost, UsePostParams } from '../../../../api';

export interface ResumeLocalAccountsProtectionPayload {
    localAccountGuids: string[];
}

export type ResumeLocalAccountsProtectionResponse = never;
export type ResumeLocalAccountsProtectionError = unknown;

export type UseResumeLocalAccountsProtectionParams = UsePostParams<
    ResumeLocalAccountsProtectionPayload,
    ResumeLocalAccountsProtectionResponse,
    ResumeLocalAccountsProtectionError
>;

export const useResumeLocalAccountsProtection = (params: UseResumeLocalAccountsProtectionParams = {}) => {
    const { post, ...rest } = usePost<
        ResumeLocalAccountsProtectionPayload,
        ResumeLocalAccountsProtectionResponse,
        ResumeLocalAccountsProtectionError
    >(params);

    const resumeLocalAccountsProtection = useCallback(
        (localAccountGuids: string[]) =>
            post(`${LOCAL_ACCOUNTS_BASE_URL}/resumeProtection`, {
                localAccountGuids
            }),
        [post]
    );

    return {
        ...rest,
        resumeLocalAccountsProtection
    };
};

export default useResumeLocalAccountsProtection;
